import { render, staticRenderFns } from "./FormTitle.vue?vue&type=template&id=714d4b82&"
import script from "./FormTitle.vue?vue&type=script&lang=ts&"
export * from "./FormTitle.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports